videojs.addLanguage('sv', 
 {
  "Play": "Play",
  "Pause": "Pause",
  "Current Time": "Current Time",
  "Duration Time": "Duration Time",
  "Remaining Time": "Remaining Time",
  "Stream Type": "Stream Type",
  "LIVE": "LIVE",
  "Loaded": "Loaded",
  "Progress": "Progress",
  "Fullscreen": "Fullscreen",
  "Non-Fullscreen": "Non-Fullscreen",
  "Mute": "Mute",
  "Unmuted": "Unmuted",
  "Playback Rate": "Playback Rate",
  "Subtitles": "Undertexter",
  "subtitles off": "Undertexter av",
  "Captions": "Captions",
  "captions off": "captions off",
  "Chapters": "Chapters",
  "You aborted the video playback": "You aborted the video playback.",
  "A network error caused the video download to fail part-way.": "Videouppspelningen tappades plötsligt, var vänlig kolla din nätuppkoppling.",
  "The video could not be loaded, either because the server or network failed or because the format is not supported.": "Filmfilen är trasig eller så stöds inte formatet av din browser.",
  "The video playback was aborted due to a corruption problem or because the video used features your browser did not support.": "Den här filmfilen är antingen inte tillgänglig så stöds inte formatet av din browser.",
  "No compatible source was found for this video.": "Ingen film har laddats.",
  
  "License for playback could not be retrieved, the license server returned an error": "License for playback could not be retrieved, the license server returned an error",
});